import { atom } from "recoil";

export const addStateDistrict = atom({
  key: "addStateDistrict",
  default: false,
});
export const editStateDistrict = atom({
  key: "editStateDistrict",
  default: false,
});
export const rowEditIdStateDistrict = atom({
  key: "rowEditIdStateDistrict",
  default: null,
});
export const disableButtonStateDistrict = atom({
  key: "disableButtonStateDistrict",
  default: false,
});

export const rowForEditStateDistrict = atom({
  key: "rowForEditStateDistrict",
  default: [],
});

export const selectedRowsStateDistrict = atom({
  key: "selectedRowsStateDistrict",
  default: [],
});
export const districtShowState = atom({
  key: "districtShowState",
  default: false,
});
export const setFilterTextDistrict = atom({
  key: "setFilterTextDistrict",
  default: "",
});

export const setCheckStatusStateDistrict = atom({
  key: "setCheckStatusStateDistrict",
  default: false,
});

export const setHiddenColumnStateDistrict = atom({
  key: "setHiddenColumnStateDistrict",
  default: false,
});

export const setLinkStateDistrict = atom({
  key: "setLinkStateDistrict",
  default: false,
});
export const setButtonLinkTextStateDistrict = atom({
  key: "setButtonLinkTextStateDistrict",
  default: "",
});

export const setHierarchyIdStateDistrict = atom({
  key: "setHierarchyIdStateDistrict",
  default: "",
});

export const setDescriptionDistrictState = atom({
  key: "setDescriptionDistrictState",
  default: "",
});

export const codeIdDistrict = atom({
  key: "codeIdDistrict",
  default: null,
});
